import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { USER_MODULE_NAMESPACE } from '../store/user/user-types.store'

const UserStore = namespace(USER_MODULE_NAMESPACE)

@Component({
  components: {
    'subnav-container': async () => import('../components/sub-navigation/SubNavigation.vue'),
    'header-container': async () => import('../components/header/Header.vue')
  }
})
class BaseContainer extends Vue {
  @UserStore.Getter userInfo: { id: number }

  @Prop({ default: true, type: [Boolean] })
  hideSub: boolean;

  @Prop({ default: false, type: [Boolean] })
  hideAddButton: boolean;

  @Prop({ default: null, type: [String] })
  AddButtonToolTip: string;

  @Prop({ default: false, type: [Boolean] })
  hideEditButton: boolean;

  @Prop({ default: '', type: [String] })
  title: string;
  @Prop({ default: '', type: [String] })
  path: string;

  @Prop({ default: false, type: [Boolean] })
  loading: boolean;
  @Prop({ default: false, type: [Boolean] })
  disconnected: boolean;

  @Emit('add')
  handleAdd (event) { }

  @Emit('add')
  handleEdit (event) {}

  @Prop({ default: null, required: false, type: [String] })
  value: string;
  @Prop({ default: true, required: false, type: [Boolean] })
  searchVisible: boolean;

  get lblSetting () {
    return {
      ...require('@/locales/button').default,
      ...require('@/locales/generic-labels').default
    }
  }

  get visible (): boolean {
    return this.userInfo.id > 0
  }

  get vModel (): string {
    return this.value
  }
  set vModel (value: string) {
    this.$emit('input', value)
  }
  get hasNoHeaderElement (): boolean {
    return this.$slots['header'] === undefined
  }
  get snackbarStatus () {
    return this.$store.getters.serviceWorker.showSnackbar
  }
  set snackbarStatus (status) {
    this.$store.commit('UPDATE_SNACKBAR_STATUS', status)
  }

  handleUpdateApp () {
    const {worker} = this.$store.getters.serviceWorker
    console.log('UPDATE THE APP**** 888', worker)
    if (worker) {
      worker.postMessage({action: 'skipWaiting'})
      this.snackbarStatus = false
    } else {
      console.log('WORKER NOT REGISTRED IN STORE 2')
    }
  }
}

export default BaseContainer



// WEBPACK FOOTER //
// ./src/containers/index.ts